const SNIPPET_APP_TYPES = {
  MULTI_PAGE_APP: 'multi',
  SINGLE_PAGE_APP: 'single'
};
function getSnippets(apiKey, host, isJwtEnabled, hasParentAccounts, appType) {
  let isAdopt = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  switch (appType) {
    case SNIPPET_APP_TYPES.MULTI_PAGE_APP:
      return multiPage(apiKey, host, isJwtEnabled, hasParentAccounts, isAdopt);
    case SNIPPET_APP_TYPES.SINGLE_PAGE_APP:
      return singlePage(apiKey, host, isJwtEnabled, hasParentAccounts, isAdopt);
  }
}
function multiPage(apiKey, host, isJwtEnabled, hasParentAccounts, isAdopt) {
  const parentAccount = !hasParentAccounts ? '' : `,

            parentAccount: {
                id:           'PARENT-ACCOUNT-UNIQUE-ID'
                // name:         // Optional

                // You can add any additional parent account level key-values here,
                // as long as it's not one of the above reserved names.
            }`;
  const fullSnippet = isAdopt ? {
    text: `<script>
(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://${host}/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

        // This function creates visitors in Pendo
        // You will need to replace <visitor-id-goes-here> with values you use in your app
        // Please use Strings, Numbers, or Bools for value types.
        pendo.initialize({
            visitor: {
                id:              <visitor-id-goes-here> // Required if user is logged in
                // role:         // Optional

                // You can add any additional visitor level key-values here,
                // as long as it's not one of the above reserved names.
            }${parentAccount}
        });
})('${apiKey}');
</script>`
  } : {
    text: `<script>
(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://${host}/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

        // This function creates visitors and accounts in Pendo
        // You will need to replace <visitor-id-goes-here> and <account-id-goes-here> with values you use in your app
        // Please use Strings, Numbers, or Bools for value types.
        pendo.initialize({
            visitor: {
                id:              <visitor-id-goes-here> // Required if user is logged in
                // email:        // Recommended if using Pendo Feedback, or NPS Email
                // full_name:    // Recommended if using Pendo Feedback
                // role:         // Optional

                // You can add any additional visitor level key-values here,
                // as long as it's not one of the above reserved names.
            },

            account: {
                id:              <account-id-goes-here> // Highly recommended, required if using Pendo Feedback
                // name:         // Optional
                // is_paying:    // Recommended if using Pendo Feedback
                // monthly_value:// Recommended if using Pendo Feedback
                // planLevel:    // Optional
                // planPrice:    // Optional
                // creationDate: // Optional

                // You can add any additional account level key-values here,
                // as long as it's not one of the above reserved names.
            }${parentAccount}
        });
})('${apiKey}');
</script>`
  };
  const fullSnippetJwt = {
    text: `<script>
(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://${host}/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

        // Call this whenever information about your visitors becomes available
        pendo.initialize({
            jwt: 'JWT-SIGNED-TOKEN', // "jwt" variable in Step 2
            signingKeyName: 'Acme-WebA-C82H7'
        });
})('${apiKey}');
</script>`
  };
  return isJwtEnabled ? [fullSnippetJwt] : [fullSnippet];
}
function singlePage(apiKey, host, isJwtEnabled, hasParentAccounts, isAdopt) {
  const parentAccount = !hasParentAccounts ? '' : `,

        parentAccount: {
            id:           'PARENT-ACCOUNT-UNIQUE-ID'
            // name:         // Optional

            // You can add any additional parent account level key-values here,
            // as long as it's not one of the above reserved names.
        }`;
  const adoptSnippet = ` //Example of Server Side Code in Node.JS

        // This function creates visitors in Pendo
        // You will need to replace <visitor-id-goes-here> with values you use in your app
        // Please use Strings, Numbers, or Bools for value types.
            pendo.initialize({
                visitor: {
                    id:              <visitor-id-goes-here> // Required if user is logged in
                    // role:         // Optional

                    // You can add any additional visitor level key-values here,
                    // as long as it's not one of the above reserved names.
                }${parentAccount}
            });`;
  const enagageSnippet = `// This function creates visitors and accounts in Pendo
    // You will need to replace <visitor-id-goes-here> and <account-id-goes-here> with values you use in your app
    // Please use Strings, Numbers, or Bools for value types.
    pendo.initialize({
        visitor: {
            id:              <visitor-id-goes-here> // Required if user is logged in
            // email:        // Recommended if using Pendo Feedback, or NPS Email
            // full_name:    // Recommended if using Pendo Feedback
            // role:         // Optional

            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
        },

        account: {
            id:              <account-id-goes-here> // Highly recommended, required if using Pendo Feedback
            // name:         // Optional
            // is_paying:    // Recommended if using Pendo Feedback
            // monthly_value:// Recommended if using Pendo Feedback
            // planLevel:    // Optional
            // planPrice:    // Optional
            // creationDate: // Optional

            // You can add any additional account level key-values here,
            // as long as it's not one of the above reserved names.
        }${parentAccount}
    });`;
  const snippet = isAdopt ? adoptSnippet : enagageSnippet;
  const snippetInitialize = isJwtEnabled ? `// Call this whenever information about your visitors becomes available
    pendo.initialize({
        jwt: 'kdlsjfsdjhfds...',
        signingKeyName: 'Acme-WebA-C82H7'
    });` : snippet;
  return [{
    text: `<script>
(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://${host}/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
})('${apiKey}');
</script>`,
    config: {
      title: 'Start by copying this to your index.html:'
    }
  }, {
    text: snippetInitialize,
    config: {
      title: 'Then, add this once your users are logged in/authenticated:'
    }
  }];
}
const engageJWTSnippet = parentAccount => {
  return `jwt = JWT.sign({
        visitor:{
            id:             <visitor-id-goes-here> // Required if user is logged in
            // email:       // Recommended if using Pendo Feedback, or NPS Email
            // full_name:   // Recommended if using Pendo Feedback
            // role:        // Optional

            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
        },

        account: {
            id:              <account-id-goes-here> // Highly recommended, required if using Pendo Feedback
            // name:         // Optional
            // is_paying:    // Recommended if using Pendo Feedback
            // monthly_value:// Recommended if using Pendo Feedback
            // planLevel:    // Optional
            // planPrice:    // Optional
            // creationDate: // Optional

            // You can add any additional account level key-values here,
            // as long as it's not one of the above reserved names.
        },${parentAccount}

        nonce: 'randomly generated value'  // It should be different every time it is used
    },
    'JWT-SECRET-KEY' // Generate this key below
    )`;
};
const adoptJWTSnippet = parentAccount => {
  return `
    //Example of Server Side Code in Node.JS

    jwt = JWT.sign({
        visitor:{
            id:             <visitor-id-goes-here> // Required if user is logged in
            // role:        // Optional

            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
        },${parentAccount}

        nonce: 'randomly generated value'  // It should be different every time it is used
    },
    'JWT-SECRET-KEY' // Generate this key below
    )`;
};

export { SNIPPET_APP_TYPES, adoptJWTSnippet, engageJWTSnippet, getSnippets, multiPage, singlePage };
//# sourceMappingURL=snippet-code.js.map
